import { NgModule } from '@angular/core';
import { CustomerAccountService } from './customer-account.service';

@NgModule({
    declarations: [
    ],
    providers: [
        CustomerAccountService
    ],
    imports: [
    ],
    exports: [
    ]
})
export class CustomerAccountServiceModule {}
